import { Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionsService } from '@shared/permission';
import { IDynamicReportType } from '../dynamic-report-general.interface';
import { DynamicReportGeneralFormComponent } from '../dynamic-report-general-form/dynamic-report-general-form.component';
import { DYNAMIC_REPORT_HTTP_LOADER, DynamicReportHttpLoader } from '../dynamic-report-http-loader.service';
import { DynamicReportGeneralDto } from '../dynamic-report-general.dto';
import { Observable, catchError, forkJoin, map, of, switchMap, throwError } from 'rxjs';
import { ToastService } from '@shared/components/toast';
import { DynamicReportGeneralModel } from '../dynamic-report-general.model';
import * as saveAs from 'file-saver';

@Component({
    selector: 'red-dynamic-report-general-edit',
    templateUrl: './dynamic-report-general-edit.component.html',
    styleUrls: ['./dynamic-report-general-edit.component.scss']
})
export class DynamicReportGeneralEditComponent {
    @ViewChild('dynamicReportGeneralFormComponent', {
        read: DynamicReportGeneralFormComponent,
        static: true,
    }) form!: DynamicReportGeneralFormComponent;
    reportTypes: IDynamicReportType[] = [];
    reportType!: string;
    saving = false;
    reportId!: number;
    item!: DynamicReportGeneralModel;

    constructor(
        @Inject(DYNAMIC_REPORT_HTTP_LOADER) private _apiService: DynamicReportHttpLoader,
        private readonly _location: Location,
        private readonly router: Router,
        private _activatedRoute: ActivatedRoute,
        private _permissionService: PermissionsService,
        private readonly _toastService: ToastService
    ) {
        this.reportTypes = (this._activatedRoute.snapshot.data['reportTypes'])?.filter((e: any) => e.permissionSlug && !this._permissionService.canDeny(e.permissionSlug)) ?? [];
        this.reportId = this._activatedRoute.snapshot.params['id'] * 1;
        this.item = this._activatedRoute.snapshot.data['item'];
        this.reportType = this._activatedRoute.snapshot.queryParams['reportType'] ?? this.item?.reportType;
    }


    save() {
        this.sendRequest()
            .subscribe({
                next: (res) => {
                    this._toastService.open({ type: 'success', title: 'Success', messages: 'Update Successfully' });
                    this.back();
                },
                error: error => {
                    let message = 'Something went wrong. Please try again later.';
                    if (error && (error.errorCode || error.message)) {
                        message = error.message ?? error.message[0];
                    }
                    this._toastService.open({ type: 'danger', title: 'Failed', messages: message });
                }
            });
    };

    saveExport() {
        this.sendRequest()
            .pipe(switchMap((report) => {
                const payload = DynamicReportGeneralDto.fromJson(report);
                return forkJoin([of(report), this._apiService.export(this.item?.id, payload).pipe(catchError(err => throwError(() => ({ ...err, id: report?.id }))))
                ])
            }))
            .subscribe({
                next: ([report, res]) => {
                    this._toastService.open({ type: 'success', title: 'Success', messages: 'Update Successfully' });
                    this.back();
                    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, `${report?.name}.xlsx`);
                },
                error: error => {
                    let message = 'Something went wrong. Please try again later.';
                    if (error && (error.errorCode || error.message)) {
                        message = error.message ?? error.message[0];
                    }
                    this._toastService.open({ type: 'danger', title: 'Failed', messages: message });
                }
            });
    }
    sendRequest(): Observable<DynamicReportGeneralModel> {
        const rawPayload = this.form?.getRawValue();
        if (!rawPayload) return of();
        const payload = DynamicReportGeneralDto.fromJson(rawPayload);
        return this._apiService.update(this.item.id, payload).pipe(
            map((report) => report),
            catchError(err => throwError(() => err))
        );
    }

    back(): void {
        // this._location.back();
        this.router.navigate([`/dynamic-report/${this.reportType ?? 'project'}`], { queryParams: { reportType: this.reportType ?? 'project' }, replaceUrl: true, queryParamsHandling: 'merge' });
    }
} 